/**
 * Получает ли крепость на центральном квартале урон от стрельбы, пока в городе
 * цел хоть один базовый квартал. По правилам урон сначала принимает
 * спецстроение (крепость — 1 к 1), и лишь остаток после ее разрушения
 * упирается в защиту центрального квартала базовыми — так урон и рисуется на
 * поле (HexGridRenderer.getBuildingRenderState). До этой правки редьюсер
 * применял защиту квартала раньше крепости, и выстрел по ней пропадал целиком.
 *
 * Записи матчей проигрываются через редьюсеры: в старой записи крепость после
 * правки получила бы урон, которого в партии не было, и остаток записи
 * разошелся бы с сыгранным. Флаг isCentralQuarterFortressDamageRule ставит
 * LOAD_STATE (см. loadState в redux/actions); у старых записей его нет —
 * только у них он false.
 *
 * @param {Object} [gameState] - состояние партии
 * @returns {boolean}
 */
export const checkIfCentralQuarterFortressDamageRule = (gameState) => (
  gameState?.isCentralQuarterFortressDamageRule !== false
);
